// contentful content types used in the app
const COMPANY_CONTACT_US_CONTENT_TYPE = 'contactUsInformation';
const SYSTEM_UNAVAILABLE_CONTENT_TYPE = 'systemUnavailable';

// keys for storing in redux
const SYSTEM_UNAVAILABLE_BANNER_KEY = 'downBanner';

// operating system for all content in the app
// used for filtering from web, android and iOS contentful entries
const SYSTEM_UNAVAILABLE_OPERATING_SYSTEM = 'Web';

// all direct contentful content types consumed in the app
export {
  COMPANY_CONTACT_US_CONTENT_TYPE,
  SYSTEM_UNAVAILABLE_BANNER_KEY,
  SYSTEM_UNAVAILABLE_CONTENT_TYPE,
  SYSTEM_UNAVAILABLE_OPERATING_SYSTEM,
};
